export default __webpack_public_path__ + "static/media/379.7cbc2dca.png";